export const OTPS = '/oas/api/v1/otps';
export const GET_MENU_ITEMS = '/web/api/v1/getmenuoptions'
export const GET_HOME_DATA = '/web/api/v1/home'

// main content
export const GET_MAIN_CONTENT_DATA = '/web/api/v1/getwebcontents'
export const GET_TOTAL_MAIN_CONTENT_DATA = '/web/api/v1/getallcontent'
export const GET_MENU_DATA = "/web/api/v1/getcontentdata";

export const FileURL = '/web/api/v1/downloadFileImage/english/';
export const CommercialImg= '/web/api/v1/downloadcommercialsimage/';